import { render, staticRenderFns } from "./Treehouse.vue?vue&type=template&id=634997e4&scoped=true"
import script from "./Treehouse.vue?vue&type=script&lang=js"
export * from "./Treehouse.vue?vue&type=script&lang=js"
import style0 from "./Treehouse.vue?vue&type=style&index=0&id=634997e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634997e4",
  null
  
)

export default component.exports